<template>
  <div>
    <div class="page-inner-header">
      <div class="page-inner-title float-left">{{ detail.name }}</div>
      <div class="float-right">
        <!--<button class="ap-btn-red ap-btn-red-hover1">采购此清单商品</button>-->
        <div class="btn-wrap" @click="save()">保存</div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-4">
        <strong>清单名称：</strong>
        <input type="text" v-model="detail.name" class="form-control" />
      </div>
      <div class="col-lg-8">
        <strong>清单描述：</strong>
        <input type="text" v-model="detail.description" class="form-control" />
      </div>
    </div>
    <div class="font12" style="margin:15px 0 10px;color:#666">商品数 （{{ detail.total }}）</div>
    <table class="table table-hover font12">
      <thead>
        <tr>
          <th>商品编号</th>
          <th>商品货号</th>
          <th>类目</th>
          <th>商品名称</th>
          <th style="width:100px">价格</th>
          <th style="width:140px">加入此单时间</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr style="cursor:pointer" v-for="it in records" :key="it.id" @click="viewDetail(it.commodityId)">
          <td>{{it.number}}</td>
          <td>{{it.productNumber}}</td>
          <td>{{it.genericCommodity}}</td>
          <td>{{it.name}}</td>
          <td style="color:#f03">{{it.price}}</td>
          <td>{{it.createdTime | toShortDateTime}}</td>
          <td>
            <a class="btn btn-sm btn-icon btn-secondary" @click="remove(it.id)" style="margin-left:10px">
              <i class="far fa-trash-alt"></i>
              <span class="sr-only">Remove</span>
            </a>
          </td>
        </tr>
      </tbody>
    </table>
    <div style="margin-top:30px">
      <Pagination :total="total" @page-to="getList" />
    </div>
  </div>
</template>

<script>
import Pagination from "@components/Pagination.vue";

export default {
  components: {
    Pagination
  },
  data() {
    return {
      total: 1,
      id: "",
      records: [],
      detail: {}
    };
  },
  created() {
    this.id = this.$route.params.id;
    this.getData();
    this.getList();
  },
  methods: {
    remove(id) {
      this.$list("/bhome/favCmdties/destroy/" + id)
        .then(res => this.getList())
        .catch(err => {});
    },
    save() {
      this.$post("/bhome/favCols/save", {
        id: this.id,
        name: this.detail.name,
        description: this.detail.description
      })
        .then(res => $msg.msg("保存成功！"))
        .catch(err => {});
    },
    getList() {
      this.$list("/bhome/favCmdties/query/" + this.id)
        .then(res => (this.records = res))
        .catch(err => {});
    },
    getData() {
      this.$get("/bhome/favCols/get/" + this.id)
        .then(res => (this.detail = res))
        .catch(err => {});
    },
    viewDetail(id) {
      let routeData = this.$router.resolve({ path: "/sku/" + id });
      window.open(routeData.href, "_blank");
    }
  }
};
</script>

<style lang="less" scoped>
.btn-wrap {
  margin-left: 20px;
  display: inline-block;
  width: 80px;
  height: 36px;
  line-height: 34px;
  font-size: 1rem;
  text-align: center;
  cursor: pointer;
  background: linear-gradient(180deg, rgba(255, 255, 255, 1) 0%, rgba(242, 242, 242, 1) 100%);
  color: #000;
  border: 1px solid rgba(228, 228, 228);
  border-radius: 2px;
  &:hover {
    background: rgba(242, 242, 242);
  }
}
</style>